import { render } from "./SimplePagination.vue?vue&type=template&id=8dc1c7e8"
import script from "./SimplePagination.vue?vue&type=script&lang=js"
export * from "./SimplePagination.vue?vue&type=script&lang=js"

import "./SimplePagination.vue?vue&type=style&index=0&id=8dc1c7e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__